/** معرّفات المعالجات الإرشادية — تُستخدم في التفضيلات وربط الخدمات */
export type SmartWizardFeatureId =
  | 'financialYear'
  | 'product'
  | 'salesInvoice'
  | 'purchaseInvoice'
  | 'chartAccounts'
  | 'contact'
  | 'shift'
  | 'users'
  | 'roles'
  | 'branch'
  | 'store'
  | 'currency'
  | 'manualInventory'
  | 'openingStock'
  | 'company'
  | 'productCategory'
  | 'receiptVoucher'
  | 'paymentVoucher'
  | 'intermediateAccount'
  | 'dailyJournal'
  | 'productsBarcode'
  | 'pos'
  | 'zatcaUnit'
  | 'electronicInvoicing';

export const SMART_WIZARD_FEATURE_IDS: readonly SmartWizardFeatureId[] = [
  'financialYear',
  'product',
  'salesInvoice',
  'purchaseInvoice',
  'chartAccounts',
  'contact',
  'shift',
  'users',
  'roles',
  'branch',
  'store',
  'currency',
  'manualInventory',
  'openingStock',
  'company',
  'productCategory',
  'receiptVoucher',
  'paymentVoucher',
  'intermediateAccount',
  'dailyJournal',
  'productsBarcode',
  'pos',
  'zatcaUnit',
  'electronicInvoicing',
] as const;
